import { combineReducers } from 'redux';

import main from './main';
import portal from './portal';
import POS from './pos';
import components from './components';

export default combineReducers({
  main,
  portal,
  POS,
  components
});
